var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.25C3.10078 1.25 0.75 3.60078 0.75 6.5C0.75 9.39922 3.10078 11.75 6 11.75C8.89922 11.75 11.25 9.39922 11.25 6.5C11.25 3.60078 8.89922 1.25 6 1.25ZM6 10.8594C3.59297 10.8594 1.64062 8.90703 1.64062 6.5C1.64062 4.09297 3.59297 2.14062 6 2.14062C8.40703 2.14062 10.3594 4.09297 10.3594 6.5C10.3594 8.90703 8.40703 10.8594 6 10.8594Z",
    fill: "#7C7B7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4375 4.4375C5.4375 4.58668 5.49676 4.72976 5.60225 4.83525C5.70774 4.94074 5.85082 5 6 5C6.14918 5 6.29226 4.94074 6.39775 4.83525C6.50324 4.72976 6.5625 4.58668 6.5625 4.4375C6.5625 4.28832 6.50324 4.14524 6.39775 4.03975C6.29226 3.93426 6.14918 3.875 6 3.875C5.85082 3.875 5.70774 3.93426 5.60225 4.03975C5.49676 4.14524 5.4375 4.28832 5.4375 4.4375ZM6.28125 5.75H5.71875C5.66719 5.75 5.625 5.79219 5.625 5.84375V9.03125C5.625 9.08281 5.66719 9.125 5.71875 9.125H6.28125C6.33281 9.125 6.375 9.08281 6.375 9.03125V5.84375C6.375 5.79219 6.33281 5.75 6.28125 5.75Z",
    fill: "#7C7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.a52f33eb7511f6fbac612395003e9f67.svg";
export { ForwardRef as ReactComponent };